export * from './MinusIcon';
export * from './MinusIcon16Light';
export * from './MinusIcon16Regular';
export * from './MinusIcon16Solid';
export * from './MinusIcon20Light';
export * from './MinusIcon20Regular';
export * from './MinusIcon20Solid';
export * from './MinusIcon24Regular';
export * from './MinusIcon24Solid';
export * from './MinusIcon32Regular';
export * from './MinusIcon64Regular';
